module.exports = __webpack_public_path__ + "static/media/chevron-right-white.3c75180e.svg";